@use '@design/design-tokens/typography/typography' as *;

.chartErrorRoot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 400px;
  min-height: 300px;
  margin: 0 auto;
}

.errorIcon {
  fill: var(--surface-neutral);
  opacity: 0.4;
  width: 70px;
  height: 70px;
}

.title {
  @include typography-v2-title-base;
  color: var(--text-default);
}

.description {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin-bottom: 16px;
}

.link {
  color: var(--text-link);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
